import { registerPlugin } from '@capacitor/core';
const driverlicense = registerPlugin('driverlicense', {
    web: () => import('./web').then(m => new m.driverlicenseWeb()),
});
export * from './definitions';
export { driverlicense };
//# sourceMappingURL=index.js.map